import axiosClient from "../common/axios/axiosConfig";
import { showToast } from "../utils/showToast";

interface IResponse {
	success: boolean;
	message: string;
	id: string;
}

/**
 * Reserva o horário escolhido
 * @param {string} scheduleId id do horário
 */
const registerCheckout = async (scheduleId: string, onRegistering?: (value: boolean) => void): Promise<IResponse | void> => {
	onRegistering && onRegistering(true);
	try {
		const response = await axiosClient.post<IResponse>("/cadastrar-checkout", {
			idHorario: scheduleId,
		});

		if (!response.data.success) {
			showToast("error", {
				timer: 10000,
				text: "O horário selecionado não está mais disponível, tente novamente com outro horário.",
			});
			return response.data;
		}

		return response.data;
	} catch {
		showToast("info", {
			timer: 10000,
			text: "O horário selecionado não está mais disponível, retorne ao menu anterior e selecione outro horário.",
		});
	} finally {
		onRegistering && onRegistering(false);
	}
};

export default registerCheckout;
